<script lang="ts">
    import {onMount} from "svelte";
    import HamburgerMenuView from "../common/Menu/HamburgerMenuView.svelte";
    import {AuthStore} from "../../store/AuthStore";
    import ImageView from "../common/Image/ImageView.svelte";

    $: authStoreAuthStatus = AuthStore.authStatus;
    $: authStoreUser = AuthStore.user;


    onMount(() => {

    });

    function onClickLogout() {

    }

</script>
<div class="header-sp-view">
    <div class="left-area">
        <div class="logo-area">
            <!--            <a href="/#/">-->
            <!--                <ImageView src="/img/logo.png"/>-->
            <!--            </a>-->

            <ImageView src="/img/logo.png"/>
        </div>
        <div id="header-left-portal-target"></div>

    </div>

    <div class="right-area">
        {#if $authStoreUser != null}
            <HamburgerMenuView>
                <div class="menu-area">
                    <div class="row auth-user">
                        <div class="company-name">
                            { $authStoreUser['company_name']  }
                        </div>
                        <div class="department-name">
                            { $authStoreUser['department_name']  }
                        </div>
                        <div class="name">
                            { $authStoreUser['name'] }
                        </div>
                    </div>
                    <div class="row">
                        <div id="header-page-portal-target"></div>
                    </div>
                    <div class="row">

                    </div>
                    <div class="row" on:click={onClickLogout}>
                        <a href="/api/auth/logout">
                            ログアウト
                        </a>
                    </div>
                </div>
            </HamburgerMenuView>
        {/if}

    </div>

</div>
<style lang="scss">
    .header-sp-view {
        background: var(--header-background);
        color: var(--header-text-color);
        height: var(--header-height);

        display: flex;
        align-items: center;

        .left-area {
            display: flex;
            align-items: center;
            flex-grow: 1;

            .logo-area {
                padding-left: 12px;
                padding-right: 12px;
                height: 100%;
                width: 100px;

                display: flex;
                align-items: center;
                justify-content: center;

                font-size: 24px;
                letter-spacing: 0.1em;


                :global(img) {


                    transition-duration: 0.25s;
                    transition-timing-function: linear;

                    width: 100%;
                    height: 40px;
                }


                &:hover {
                    > a {
                        .logo-front {
                            transform: rotateX(90deg);
                            transition-delay: 0s;

                        }

                        .logo-back {
                            transform: rotateX(0deg);
                            transition-delay: 0.25s;

                        }
                    }
                }

            }


        }


        .right-area {


            padding-right: 12px;
            display: flex;
            align-items: center;


        }

    }


    .menu-area {
        text-align: right;

        .auth-user {


            .company-name {
                font-size: 0.5em;
                opacity: 0.5;
            }

            .department-name {
                font-size: 0.75em;
            }

            .name {
                text-align: right;
            }
        }

    }

</style>